package linkerpangoquipdb

import kotlin.Long

public data class Maintenance_spare_parts(
  public val maintenance_id: Long,
  public val spare_part_id: Long,
)
